import { render, staticRenderFns } from "./add.vue?vue&type=template&id=2106f632&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106f632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2106f632')) {
      api.createRecord('2106f632', component.options)
    } else {
      api.reload('2106f632', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=2106f632&scoped=true&", function () {
      api.rerender('2106f632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/h5/show/add.vue"
export default component.exports